var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting-main-container" }, [
    _c(
      "form",
      {
        staticClass: "mt-3",
        attrs: { action: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submitBusinessData($event)
          },
        },
      },
      [
        _c("div", { staticClass: "card setting-card" }, [
          _c("div", { staticClass: "page-header" }, [
            _c("h3", { staticClass: "page-title" }, [
              _vm._v(_vm._s(_vm.$t("profile.business_nature.business_nature"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-12 mb-4 form-group" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$tc(
                        "profile.borrowerProfile.businessDetails.business_name"
                      )
                    )
                  ),
                ]),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
                _vm._v(" "),
                _c("base-input", {
                  on: {
                    input: function ($event) {
                      return _vm.$v.formData.name.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "name", $$v)
                    },
                    expression: "formData.name",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.name.$error
                  ? _c("div", [
                      !_vm.$v.formData.name.required
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$tc("validation.required")) +
                                "\n              "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-12 mb-4 form-group" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$tc("profile.borrowerProfile.businessDetails.address")
                    )
                  ),
                ]),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
                _vm._v(" "),
                _c("base-input", {
                  on: {
                    input: function ($event) {
                      return _vm.$v.formData.address.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.address,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "address", $$v)
                    },
                    expression: "formData.address",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.address.$error
                  ? _c("div", [
                      !_vm.$v.formData.address.required
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$tc("validation.required")) +
                                "\n              "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-12 mb-4 form-group" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$tc(
                        "profile.borrowerProfile.businessDetails.business_phone"
                      )
                    )
                  ),
                ]),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
                _vm._v(" "),
                _c("base-input", {
                  on: {
                    input: function ($event) {
                      return _vm.$v.formData.phone.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.phone,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "phone", $$v)
                    },
                    expression: "formData.phone",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.phone.$error
                  ? _c("div", [
                      !_vm.$v.formData.phone.required
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$tc("validation.required")) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 mb-4 form-group" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$tc(
                        "profile.borrowerProfile.businessDetails.sales_tax_num"
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("base-input", {
                  on: {
                    input: function ($event) {
                      return _vm.$v.formData.sale_tax.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.sale_tax,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "sale_tax", $$v)
                    },
                    expression: "formData.sale_tax",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.sale_tax.$error
                  ? _c("div", [
                      !_vm.$v.formData.sale_tax.numeric
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$tc("validation.numbers_only")) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 mb-4 form-group" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$tc("profile.borrowerProfile.businessDetails.email")
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("base-input", {
                  on: {
                    input: function ($event) {
                      return _vm.$v.formData.email.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.email,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "email", $$v)
                    },
                    expression: "formData.email",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.email.$error
                  ? _c("div", [
                      !_vm.$v.formData.email.email
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$tc("validation.email_incorrect")) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 mb-4 form-group" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$tc(
                        "profile.borrowerProfile.businessDetails.importing_registration"
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("base-input", {
                  model: {
                    value: _vm.formData.importing_registration,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "importing_registration", $$v)
                    },
                    expression: "formData.importing_registration",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 mb-4 form-group" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$tc(
                        "profile.borrowerProfile.businessDetails.exporting_registration"
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("base-input", {
                  model: {
                    value: _vm.formData.exporting_registration,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "exporting_registration", $$v)
                    },
                    expression: "formData.exporting_registration",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 mb-4 form-group" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$tc(
                        "profile.borrowerProfile.businessDetails.date_establishment"
                      )
                    )
                  ),
                ]),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
                _vm._v(" "),
                _c("base-date-picker", {
                  attrs: {
                    "calendar-button": true,
                    "calendar-button-icon": "calendar",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$v.formData.date_establishment.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.date_establishment,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "date_establishment", $$v)
                    },
                    expression: "formData.date_establishment",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.date_establishment.$error
                  ? _c("div", [
                      !_vm.$v.formData.date_establishment.required
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$tc("validation.required")) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 mb-4 form-group" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$tc(
                        "profile.borrowerProfile.businessDetails.date_opening_ac"
                      )
                    )
                  ),
                ]),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
                _vm._v(" "),
                _c("base-date-picker", {
                  attrs: {
                    "calendar-button": true,
                    "calendar-button-icon": "calendar",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$v.formData.date_openingAc.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.date_openingAc,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "date_openingAc", $$v)
                    },
                    expression: "formData.date_openingAc",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.date_openingAc.$error
                  ? _c("div", [
                      !_vm.$v.formData.date_openingAc.required
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$tc("validation.required")) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row pb-3" }, [
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c(
                  "base-button",
                  { attrs: { icon: "save", color: "theme", type: "submit" } },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("settings.customization.save")) +
                        "\n          "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }